export enum ESimpleThemeColorNames {
    pageBackground = 'page-background',
    contentBackground = 'content-background',
    text = 'text',
    primary = 'primary',
    secondary = 'secondary',
}
